import React from "react";
import { Button, Divider } from "../../index";

export const ModalFooterButtons = ({
    align,
    branded,
    buttons,
}) => {

    const modalFooterButtonsClasses = [
        `bsw-modal-footer-buttons`,
        `${align ? `bsw-modal-footer-buttons--align-${align}` : ''}`,
    ].join(' ');

    return (<>
        {(buttons?.length > 1 && !branded ) && <Divider mLeft="none" mRight="none" mTop="none" mBottom="none" />}
        <div className={modalFooterButtonsClasses}>
            {buttons?.length > 0 &&
                buttons.map((item, index) => {
                    return (<React.Fragment key={index}>
                        <Button
                            variant={item.variant ? item.variant : (index.toString() === "0" && buttons?.length > 1) ? "secondary" : "primary" }
                            onClick={item.onClick}
                        >
                            {item.label}
                        </Button>
                    </React.Fragment>)
                })
            }
        </div>
        </>
    );
}